// data from https://restcountries.com/v3.1/all?fields=name,cca2,flags

export const COUNTRY_DETAILS = {
  'Puerto Rico': {
    flag: 'https://flagcdn.com/pr.svg',
    name: 'Puerto Rico',
    alpha2Code: 'PR',
  },
  Netherlands: {
    flag: 'https://flagcdn.com/nl.svg',
    name: 'Netherlands',
    alpha2Code: 'NL',
  },
  Latvia: {
    flag: 'https://flagcdn.com/lv.svg',
    name: 'Latvia',
    alpha2Code: 'LV',
  },
  Singapore: {
    flag: 'https://flagcdn.com/sg.svg',
    name: 'Singapore',
    alpha2Code: 'SG',
  },
  Andorra: {
    flag: 'https://flagcdn.com/ad.svg',
    name: 'Andorra',
    alpha2Code: 'AD',
  },
  Curaçao: {
    flag: 'https://flagcdn.com/cw.svg',
    name: 'Curaçao',
    alpha2Code: 'CW',
  },
  Haiti: {
    flag: 'https://flagcdn.com/ht.svg',
    name: 'Haiti',
    alpha2Code: 'HT',
  },
  Djibouti: {
    flag: 'https://flagcdn.com/dj.svg',
    name: 'Djibouti',
    alpha2Code: 'DJ',
  },
  Mongolia: {
    flag: 'https://flagcdn.com/mn.svg',
    name: 'Mongolia',
    alpha2Code: 'MN',
  },
  'North Korea': {
    flag: 'https://flagcdn.com/kp.svg',
    name: 'North Korea',
    alpha2Code: 'KP',
  },
  Turkey: {
    flag: 'https://flagcdn.com/tr.svg',
    name: 'Turkey',
    alpha2Code: 'TR',
  },
  Canada: {
    flag: 'https://flagcdn.com/ca.svg',
    name: 'Canada',
    alpha2Code: 'CA',
  },
  Madagascar: {
    flag: 'https://flagcdn.com/mg.svg',
    name: 'Madagascar',
    alpha2Code: 'MG',
  },
  'Åland Islands': {
    flag: 'https://flagcdn.com/ax.svg',
    name: 'Åland Islands',
    alpha2Code: 'AX',
  },
  'New Zealand': {
    flag: 'https://flagcdn.com/nz.svg',
    name: 'New Zealand',
    alpha2Code: 'NZ',
  },
  Cuba: {
    flag: 'https://flagcdn.com/cu.svg',
    name: 'Cuba',
    alpha2Code: 'CU',
  },
  Malawi: {
    flag: 'https://flagcdn.com/mw.svg',
    name: 'Malawi',
    alpha2Code: 'MW',
  },
  'Dominican Republic': {
    flag: 'https://flagcdn.com/do.svg',
    name: 'Dominican Republic',
    alpha2Code: 'DO',
  },
  Gabon: {
    flag: 'https://flagcdn.com/ga.svg',
    name: 'Gabon',
    alpha2Code: 'GA',
  },
  Kuwait: {
    flag: 'https://flagcdn.com/kw.svg',
    name: 'Kuwait',
    alpha2Code: 'KW',
  },
  Palau: {
    flag: 'https://flagcdn.com/pw.svg',
    name: 'Palau',
    alpha2Code: 'PW',
  },
  'Falkland Islands': {
    flag: 'https://flagcdn.com/fk.svg',
    name: 'Falkland Islands',
    alpha2Code: 'FK',
  },
  'Caribbean Netherlands': {
    flag: 'https://flagcdn.com/bq.svg',
    name: 'Caribbean Netherlands',
    alpha2Code: 'BQ',
  },
  Vietnam: {
    flag: 'https://flagcdn.com/vn.svg',
    name: 'Vietnam',
    alpha2Code: 'VN',
  },
  Bangladesh: {
    flag: 'https://flagcdn.com/bd.svg',
    name: 'Bangladesh',
    alpha2Code: 'BD',
  },
  Panama: {
    flag: 'https://flagcdn.com/pa.svg',
    name: 'Panama',
    alpha2Code: 'PA',
  },
  Comoros: {
    flag: 'https://flagcdn.com/km.svg',
    name: 'Comoros',
    alpha2Code: 'KM',
  },
  Myanmar: {
    flag: 'https://flagcdn.com/mm.svg',
    name: 'Myanmar',
    alpha2Code: 'MM',
  },
  Poland: {
    flag: 'https://flagcdn.com/pl.svg',
    name: 'Poland',
    alpha2Code: 'PL',
  },
  Mauritania: {
    flag: 'https://flagcdn.com/mr.svg',
    name: 'Mauritania',
    alpha2Code: 'MR',
  },
  Greenland: {
    flag: 'https://flagcdn.com/gl.svg',
    name: 'Greenland',
    alpha2Code: 'GL',
  },
  Kenya: {
    flag: 'https://flagcdn.com/ke.svg',
    name: 'Kenya',
    alpha2Code: 'KE',
  },
  Montenegro: {
    flag: 'https://flagcdn.com/me.svg',
    name: 'Montenegro',
    alpha2Code: 'ME',
  },
  Finland: {
    flag: 'https://flagcdn.com/fi.svg',
    name: 'Finland',
    alpha2Code: 'FI',
  },
  Germany: {
    flag: 'https://flagcdn.com/de.svg',
    name: 'Germany',
    alpha2Code: 'DE',
  },
  Hungary: {
    flag: 'https://flagcdn.com/hu.svg',
    name: 'Hungary',
    alpha2Code: 'HU',
  },
  Ethiopia: {
    flag: 'https://flagcdn.com/et.svg',
    name: 'Ethiopia',
    alpha2Code: 'ET',
  },
  'French Guiana': {
    flag: 'https://flagcdn.com/gf.svg',
    name: 'French Guiana',
    alpha2Code: 'GF',
  },
  'Heard Island and McDonald Islands': {
    flag: 'https://flagcdn.com/hm.svg',
    name: 'Heard Island and McDonald Islands',
    alpha2Code: 'HM',
  },
  Bulgaria: {
    flag: 'https://flagcdn.com/bg.svg',
    name: 'Bulgaria',
    alpha2Code: 'BG',
  },
  'Papua New Guinea': {
    flag: 'https://flagcdn.com/pg.svg',
    name: 'Papua New Guinea',
    alpha2Code: 'PG',
  },
  Belgium: {
    flag: 'https://flagcdn.com/be.svg',
    name: 'Belgium',
    alpha2Code: 'BE',
  },
  'South Korea': {
    flag: 'https://flagcdn.com/kr.svg',
    name: 'South Korea',
    alpha2Code: 'KR',
  },
  Malaysia: {
    flag: 'https://flagcdn.com/my.svg',
    name: 'Malaysia',
    alpha2Code: 'MY',
  },
  Guernsey: {
    flag: 'https://flagcdn.com/gg.svg',
    name: 'Guernsey',
    alpha2Code: 'GG',
  },
  Japan: {
    flag: 'https://flagcdn.com/jp.svg',
    name: 'Japan',
    alpha2Code: 'JP',
  },
  'Cayman Islands': {
    flag: 'https://flagcdn.com/ky.svg',
    name: 'Cayman Islands',
    alpha2Code: 'KY',
  },
  Rwanda: {
    flag: 'https://flagcdn.com/rw.svg',
    name: 'Rwanda',
    alpha2Code: 'RW',
  },
  Mali: {
    flag: 'https://flagcdn.com/ml.svg',
    name: 'Mali',
    alpha2Code: 'ML',
  },
  Croatia: {
    flag: 'https://flagcdn.com/hr.svg',
    name: 'Croatia',
    alpha2Code: 'HR',
  },
  'New Caledonia': {
    flag: 'https://flagcdn.com/nc.svg',
    name: 'New Caledonia',
    alpha2Code: 'NC',
  },
  Brazil: {
    flag: 'https://flagcdn.com/br.svg',
    name: 'Brazil',
    alpha2Code: 'BR',
  },
  Bolivia: {
    flag: 'https://flagcdn.com/bo.svg',
    name: 'Bolivia',
    alpha2Code: 'BO',
  },
  'Cabo Verde': {
    flag: 'https://flagcdn.com/cv.svg',
    name: 'Cabo Verde',
    alpha2Code: 'CV',
  },
  'Turks and Caicos Islands': {
    flag: 'https://flagcdn.com/tc.svg',
    name: 'Turks and Caicos Islands',
    alpha2Code: 'TC',
  },
  'United Arab Emirates': {
    flag: 'https://flagcdn.com/ae.svg',
    name: 'United Arab Emirates',
    alpha2Code: 'AE',
  },
  Malta: {
    flag: 'https://flagcdn.com/mt.svg',
    name: 'Malta',
    alpha2Code: 'MT',
  },
  Qatar: {
    flag: 'https://flagcdn.com/qa.svg',
    name: 'Qatar',
    alpha2Code: 'QA',
  },
  Uruguay: {
    flag: 'https://flagcdn.com/uy.svg',
    name: 'Uruguay',
    alpha2Code: 'UY',
  },
  Egypt: {
    flag: 'https://flagcdn.com/eg.svg',
    name: 'Egypt',
    alpha2Code: 'EG',
  },
  'Cook Islands': {
    flag: 'https://flagcdn.com/ck.svg',
    name: 'Cook Islands',
    alpha2Code: 'CK',
  },
  Austria: {
    flag: 'https://flagcdn.com/at.svg',
    name: 'Austria',
    alpha2Code: 'AT',
  },
  Benin: {
    flag: 'https://flagcdn.com/bj.svg',
    name: 'Benin',
    alpha2Code: 'BJ',
  },
  Mexico: {
    flag: 'https://flagcdn.com/mx.svg',
    name: 'Mexico',
    alpha2Code: 'MX',
  },
  Switzerland: {
    flag: 'https://flagcdn.com/ch.svg',
    name: 'Switzerland',
    alpha2Code: 'CH',
  },
  France: {
    flag: 'https://flagcdn.com/fr.svg',
    name: 'France',
    alpha2Code: 'FR',
  },
  Greece: {
    flag: 'https://flagcdn.com/gr.svg',
    name: 'Greece',
    alpha2Code: 'GR',
  },
  Palestine: {
    flag: 'https://flagcdn.com/ps.svg',
    name: 'Palestine',
    alpha2Code: 'PS',
  },
  Somalia: {
    flag: 'https://flagcdn.com/so.svg',
    name: 'Somalia',
    alpha2Code: 'SO',
  },
  Moldova: {
    flag: 'https://flagcdn.com/md.svg',
    name: 'Moldova',
    alpha2Code: 'MD',
  },
  Zimbabwe: {
    flag: 'https://flagcdn.com/zw.svg',
    name: 'Zimbabwe',
    alpha2Code: 'ZW',
  },
  'Virgin Islands (British)': {
    flag: 'https://flagcdn.com/vg.svg',
    name: 'Virgin Islands (British)',
    alpha2Code: 'VG',
  },
  'Svalbard and Jan Mayen': {
    flag: 'https://flagcdn.com/sj.svg',
    name: 'Svalbard and Jan Mayen',
    alpha2Code: 'SJ',
  },
  'Costa Rica': {
    flag: 'https://flagcdn.com/cr.svg',
    name: 'Costa Rica',
    alpha2Code: 'CR',
  },
  Thailand: {
    flag: 'https://flagcdn.com/th.svg',
    name: 'Thailand',
    alpha2Code: 'TH',
  },
  'United States Minor Outlying Islands': {
    flag: 'https://flagcdn.com/um.svg',
    name: 'United States Minor Outlying Islands',
    alpha2Code: 'UM',
  },
  Slovenia: {
    flag: 'https://flagcdn.com/si.svg',
    name: 'Slovenia',
    alpha2Code: 'SI',
  },
  Azerbaijan: {
    flag: 'https://flagcdn.com/az.svg',
    name: 'Azerbaijan',
    alpha2Code: 'AZ',
  },
  'French Southern Territories': {
    flag: 'https://flagcdn.com/tf.svg',
    name: 'French Southern Territories',
    alpha2Code: 'TF',
  },
  'Sierra Leone': {
    flag: 'https://flagcdn.com/sl.svg',
    name: 'Sierra Leone',
    alpha2Code: 'SL',
  },
  'Saint Kitts and Nevis': {
    flag: 'https://flagcdn.com/kn.svg',
    name: 'Saint Kitts and Nevis',
    alpha2Code: 'KN',
  },
  Tunisia: {
    flag: 'https://flagcdn.com/tn.svg',
    name: 'Tunisia',
    alpha2Code: 'TN',
  },
  Guinea: {
    flag: 'https://flagcdn.com/gn.svg',
    name: 'Guinea',
    alpha2Code: 'GN',
  },
  Tokelau: {
    flag: 'https://flagcdn.com/tk.svg',
    name: 'Tokelau',
    alpha2Code: 'TK',
  },
  Italy: {
    flag: 'https://flagcdn.com/it.svg',
    name: 'Italy',
    alpha2Code: 'IT',
  },
  'Saint Pierre and Miquelon': {
    flag: 'https://flagcdn.com/pm.svg',
    name: 'Saint Pierre and Miquelon',
    alpha2Code: 'PM',
  },
  Togo: {
    flag: 'https://flagcdn.com/tg.svg',
    name: 'Togo',
    alpha2Code: 'TG',
  },
  'Christmas Island': {
    flag: 'https://flagcdn.com/cx.svg',
    name: 'Christmas Island',
    alpha2Code: 'CX',
  },
  'Wallis and Futuna': {
    flag: 'https://flagcdn.com/wf.svg',
    name: 'Wallis and Futuna',
    alpha2Code: 'WF',
  },
  Monaco: {
    flag: 'https://flagcdn.com/mc.svg',
    name: 'Monaco',
    alpha2Code: 'MC',
  },
  'Equatorial Guinea': {
    flag: 'https://flagcdn.com/gq.svg',
    name: 'Equatorial Guinea',
    alpha2Code: 'GQ',
  },
  'Timor-Leste': {
    flag: 'https://flagcdn.com/tl.svg',
    name: 'Timor-Leste',
    alpha2Code: 'TL',
  },
  Taiwan: {
    flag: 'https://flagcdn.com/tw.svg',
    name: 'Taiwan',
    alpha2Code: 'TW',
  },
  'Republic of Kosovo': {
    flag: 'https://flagcdn.com/xk.svg',
    name: 'Republic of Kosovo',
    alpha2Code: 'XK',
  },
  Niue: {
    flag: 'https://flagcdn.com/nu.svg',
    name: 'Niue',
    alpha2Code: 'NU',
  },
  Romania: {
    flag: 'https://flagcdn.com/ro.svg',
    name: 'Romania',
    alpha2Code: 'RO',
  },
  Nepal: {
    flag: 'https://flagcdn.com/np.svg',
    name: 'Nepal',
    alpha2Code: 'NP',
  },
  India: {
    flag: 'https://flagcdn.com/in.svg',
    name: 'India',
    alpha2Code: 'IN',
  },
  Gambia: {
    flag: 'https://flagcdn.com/gm.svg',
    name: 'Gambia',
    alpha2Code: 'GM',
  },
  Gibraltar: {
    flag: 'https://flagcdn.com/gi.svg',
    name: 'Gibraltar',
    alpha2Code: 'GI',
  },
  Peru: {
    flag: 'https://flagcdn.com/pe.svg',
    name: 'Peru',
    alpha2Code: 'PE',
  },
  Eswatini: {
    flag: 'https://flagcdn.com/sz.svg',
    name: 'Eswatini',
    alpha2Code: 'SZ',
  },
  Turkmenistan: {
    flag: 'https://flagcdn.com/tm.svg',
    name: 'Turkmenistan',
    alpha2Code: 'TM',
  },
  'Vatican City': {
    flag: 'https://flagcdn.com/va.svg',
    name: 'Vatican City',
    alpha2Code: 'VA',
  },
  'Faroe Islands': {
    flag: 'https://flagcdn.com/fo.svg',
    name: 'Faroe Islands',
    alpha2Code: 'FO',
  },
  'Saint Vincent and the Grenadines': {
    flag: 'https://flagcdn.com/vc.svg',
    name: 'Saint Vincent and the Grenadines',
    alpha2Code: 'VC',
  },
  Micronesia: {
    flag: 'https://flagcdn.com/fm.svg',
    name: 'Micronesia',
    alpha2Code: 'FM',
  },
  Eritrea: {
    flag: 'https://flagcdn.com/er.svg',
    name: 'Eritrea',
    alpha2Code: 'ER',
  },
  Kazakhstan: {
    flag: 'https://flagcdn.com/kz.svg',
    name: 'Kazakhstan',
    alpha2Code: 'KZ',
  },
  Aruba: {
    flag: 'https://flagcdn.com/aw.svg',
    name: 'Aruba',
    alpha2Code: 'AW',
  },
  Bahrain: {
    flag: 'https://flagcdn.com/bh.svg',
    name: 'Bahrain',
    alpha2Code: 'BH',
  },
  Mayotte: {
    flag: 'https://flagcdn.com/yt.svg',
    name: 'Mayotte',
    alpha2Code: 'YT',
  },
  Iran: {
    flag: 'https://flagcdn.com/ir.svg',
    name: 'Iran',
    alpha2Code: 'IR',
  },
  Uganda: {
    flag: 'https://flagcdn.com/ug.svg',
    name: 'Uganda',
    alpha2Code: 'UG',
  },
  'Norfolk Island': {
    flag: 'https://flagcdn.com/nf.svg',
    name: 'Norfolk Island',
    alpha2Code: 'NF',
  },
  Martinique: {
    flag: 'https://flagcdn.com/mq.svg',
    name: 'Martinique',
    alpha2Code: 'MQ',
  },
  Tuvalu: {
    flag: 'https://flagcdn.com/tv.svg',
    name: 'Tuvalu',
    alpha2Code: 'TV',
  },
  China: {
    flag: 'https://flagcdn.com/cn.svg',
    name: 'China',
    alpha2Code: 'CN',
  },
  'United States of America': {
    flag: 'https://flagcdn.com/us.svg',
    name: 'United States of America',
    alpha2Code: 'US',
  },
  'Marshall Islands': {
    flag: 'https://flagcdn.com/mh.svg',
    name: 'Marshall Islands',
    alpha2Code: 'MH',
  },
  Sweden: {
    flag: 'https://flagcdn.com/se.svg',
    name: 'Sweden',
    alpha2Code: 'SE',
  },
  'El Salvador': {
    flag: 'https://flagcdn.com/sv.svg',
    name: 'El Salvador',
    alpha2Code: 'SV',
  },
  'Isle of Man': {
    flag: 'https://flagcdn.com/im.svg',
    name: 'Isle of Man',
    alpha2Code: 'IM',
  },
  Armenia: {
    flag: 'https://flagcdn.com/am.svg',
    name: 'Armenia',
    alpha2Code: 'AM',
  },
  Jordan: {
    flag: 'https://flagcdn.com/jo.svg',
    name: 'Jordan',
    alpha2Code: 'JO',
  },
  Lebanon: {
    flag: 'https://flagcdn.com/lb.svg',
    name: 'Lebanon',
    alpha2Code: 'LB',
  },
  Angola: {
    flag: 'https://flagcdn.com/ao.svg',
    name: 'Angola',
    alpha2Code: 'AO',
  },
  Venezuela: {
    flag: 'https://flagcdn.com/ve.svg',
    name: 'Venezuela',
    alpha2Code: 'VE',
  },
  'Pitcairn Islands': {
    flag: 'https://flagcdn.com/pn.svg',
    name: 'Pitcairn Islands',
    alpha2Code: 'PN',
  },
  Afghanistan: {
    flag: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg',
    name: 'Afghanistan',
    alpha2Code: 'AF',
  },
  'DR Congo': {
    flag: 'https://flagcdn.com/cd.svg',
    name: 'DR Congo',
    alpha2Code: 'CD',
  },
  'Hong Kong': {
    flag: 'https://flagcdn.com/hk.svg',
    name: 'Hong Kong',
    alpha2Code: 'HK',
  },
  'Northern Mariana Islands': {
    flag: 'https://flagcdn.com/mp.svg',
    name: 'Northern Mariana Islands',
    alpha2Code: 'MP',
  },
  'Antigua and Barbuda': {
    flag: 'https://flagcdn.com/ag.svg',
    name: 'Antigua and Barbuda',
    alpha2Code: 'AG',
  },
  Portugal: {
    flag: 'https://flagcdn.com/pt.svg',
    name: 'Portugal',
    alpha2Code: 'PT',
  },
  Tajikistan: {
    flag: 'https://flagcdn.com/tj.svg',
    name: 'Tajikistan',
    alpha2Code: 'TJ',
  },
  Guam: {
    flag: 'https://flagcdn.com/gu.svg',
    name: 'Guam',
    alpha2Code: 'GU',
  },
  Syria: {
    flag: 'https://flagcdn.com/sy.svg',
    name: 'Syria',
    alpha2Code: 'SY',
  },
  Suriname: {
    flag: 'https://flagcdn.com/sr.svg',
    name: 'Suriname',
    alpha2Code: 'SR',
  },
  'Czech Republic': {
    flag: 'https://flagcdn.com/cz.svg',
    name: 'Czech Republic',
    alpha2Code: 'CZ',
  },
  'Saint Lucia': {
    flag: 'https://flagcdn.com/lc.svg',
    name: 'Saint Lucia',
    alpha2Code: 'LC',
  },
  Russia: {
    flag: 'https://flagcdn.com/ru.svg',
    name: 'Russia',
    alpha2Code: 'RU',
  },
  Colombia: {
    flag: 'https://flagcdn.com/co.svg',
    name: 'Colombia',
    alpha2Code: 'CO',
  },
  Cyprus: {
    flag: 'https://flagcdn.com/cy.svg',
    name: 'Cyprus',
    alpha2Code: 'CY',
  },
  Australia: {
    flag: 'https://flagcdn.com/au.svg',
    name: 'Australia',
    alpha2Code: 'AU',
  },
  Niger: {
    flag: 'https://flagcdn.com/ne.svg',
    name: 'Niger',
    alpha2Code: 'NE',
  },
  Chad: {
    flag: 'https://flagcdn.com/td.svg',
    name: 'Chad',
    alpha2Code: 'TD',
  },
  'American Samoa': {
    flag: 'https://flagcdn.com/as.svg',
    name: 'American Samoa',
    alpha2Code: 'AS',
  },
  'United Kingdom': {
    flag: 'https://flagcdn.com/gb.svg',
    name: 'United Kingdom',
    alpha2Code: 'GB',
  },
  'Guinea-Bissau': {
    flag: 'https://flagcdn.com/gw.svg',
    name: 'Guinea-Bissau',
    alpha2Code: 'GW',
  },
  Kiribati: {
    flag: 'https://flagcdn.com/ki.svg',
    name: 'Kiribati',
    alpha2Code: 'KI',
  },
  Maldives: {
    flag: 'https://flagcdn.com/mv.svg',
    name: 'Maldives',
    alpha2Code: 'MV',
  },
  'South Georgia': {
    flag: 'https://flagcdn.com/gs.svg',
    name: 'South Georgia',
    alpha2Code: 'GS',
  },
  Nicaragua: {
    flag: 'https://flagcdn.com/ni.svg',
    name: 'Nicaragua',
    alpha2Code: 'NI',
  },
  'Saudi Arabia': {
    flag: 'https://flagcdn.com/sa.svg',
    name: 'Saudi Arabia',
    alpha2Code: 'SA',
  },
  Belarus: {
    flag: 'https://flagcdn.com/by.svg',
    name: 'Belarus',
    alpha2Code: 'BY',
  },
  Samoa: {
    flag: 'https://flagcdn.com/ws.svg',
    name: 'Samoa',
    alpha2Code: 'WS',
  },
  Seychelles: {
    flag: 'https://flagcdn.com/sc.svg',
    name: 'Seychelles',
    alpha2Code: 'SC',
  },
  Zambia: {
    flag: 'https://flagcdn.com/zm.svg',
    name: 'Zambia',
    alpha2Code: 'ZM',
  },
  Mauritius: {
    flag: 'https://flagcdn.com/mu.svg',
    name: 'Mauritius',
    alpha2Code: 'MU',
  },
  'South Sudan': {
    flag: 'https://flagcdn.com/ss.svg',
    name: 'South Sudan',
    alpha2Code: 'SS',
  },
  Guyana: {
    flag: 'https://flagcdn.com/gy.svg',
    name: 'Guyana',
    alpha2Code: 'GY',
  },
  'South Africa': {
    flag: 'https://flagcdn.com/za.svg',
    name: 'South Africa',
    alpha2Code: 'ZA',
  },
  'Western Sahara': {
    flag: 'https://flagcdn.com/eh.svg',
    name: 'Western Sahara',
    alpha2Code: 'EH',
  },
  Vanuatu: {
    flag: 'https://flagcdn.com/vu.svg',
    name: 'Vanuatu',
    alpha2Code: 'VU',
  },
  Belize: {
    flag: 'https://flagcdn.com/bz.svg',
    name: 'Belize',
    alpha2Code: 'BZ',
  },
  Cambodia: {
    flag: 'https://flagcdn.com/kh.svg',
    name: 'Cambodia',
    alpha2Code: 'KH',
  },
  Ukraine: {
    flag: 'https://flagcdn.com/ua.svg',
    name: 'Ukraine',
    alpha2Code: 'UA',
  },
  'Bosnia and Herzegovina': {
    flag: 'https://flagcdn.com/ba.svg',
    name: 'Bosnia and Herzegovina',
    alpha2Code: 'BA',
  },
  Luxembourg: {
    flag: 'https://flagcdn.com/lu.svg',
    name: 'Luxembourg',
    alpha2Code: 'LU',
  },
  Senegal: {
    flag: 'https://flagcdn.com/sn.svg',
    name: 'Senegal',
    alpha2Code: 'SN',
  },
  Réunion: {
    flag: 'https://flagcdn.com/re.svg',
    name: 'Réunion',
    alpha2Code: 'RE',
  },
  Spain: {
    flag: 'https://flagcdn.com/es.svg',
    name: 'Spain',
    alpha2Code: 'ES',
  },
  Algeria: {
    flag: 'https://flagcdn.com/dz.svg',
    name: 'Algeria',
    alpha2Code: 'DZ',
  },
  Georgia: {
    flag: 'https://flagcdn.com/ge.svg',
    name: 'Georgia',
    alpha2Code: 'GE',
  },
  Sudan: {
    flag: 'https://flagcdn.com/sd.svg',
    name: 'Sudan',
    alpha2Code: 'SD',
  },
  'Central African Republic': {
    flag: 'https://flagcdn.com/cf.svg',
    name: 'Central African Republic',
    alpha2Code: 'CF',
  },
  Tanzania: {
    flag: 'https://flagcdn.com/tz.svg',
    name: 'Tanzania',
    alpha2Code: 'TZ',
  },
  Burundi: {
    flag: 'https://flagcdn.com/bi.svg',
    name: 'Burundi',
    alpha2Code: 'BI',
  },
  Denmark: {
    flag: 'https://flagcdn.com/dk.svg',
    name: 'Denmark',
    alpha2Code: 'DK',
  },
  Mozambique: {
    flag: 'https://flagcdn.com/mz.svg',
    name: 'Mozambique',
    alpha2Code: 'MZ',
  },
  'Trinidad and Tobago': {
    flag: 'https://flagcdn.com/tt.svg',
    name: 'Trinidad and Tobago',
    alpha2Code: 'TT',
  },
  Cameroon: {
    flag: 'https://flagcdn.com/cm.svg',
    name: 'Cameroon',
    alpha2Code: 'CM',
  },
  'North Macedonia': {
    flag: 'https://flagcdn.com/mk.svg',
    name: 'North Macedonia',
    alpha2Code: 'MK',
  },
  Libya: {
    flag: 'https://flagcdn.com/ly.svg',
    name: 'Libya',
    alpha2Code: 'LY',
  },
  Tonga: {
    flag: 'https://flagcdn.com/to.svg',
    name: 'Tonga',
    alpha2Code: 'TO',
  },
  'San Marino': {
    flag: 'https://flagcdn.com/sm.svg',
    name: 'San Marino',
    alpha2Code: 'SM',
  },
  Philippines: {
    flag: 'https://flagcdn.com/ph.svg',
    name: 'Philippines',
    alpha2Code: 'PH',
  },
  Paraguay: {
    flag: 'https://flagcdn.com/py.svg',
    name: 'Paraguay',
    alpha2Code: 'PY',
  },
  Jersey: {
    flag: 'https://flagcdn.com/je.svg',
    name: 'Jersey',
    alpha2Code: 'JE',
  },
  Bhutan: {
    flag: 'https://flagcdn.com/bt.svg',
    name: 'Bhutan',
    alpha2Code: 'BT',
  },
  Serbia: {
    flag: 'https://flagcdn.com/rs.svg',
    name: 'Serbia',
    alpha2Code: 'RS',
  },
  Antarctica: {
    flag: 'https://flagcdn.com/aq.svg',
    name: 'Antarctica',
    alpha2Code: 'AQ',
  },
  Lesotho: {
    flag: 'https://flagcdn.com/ls.svg',
    name: 'Lesotho',
    alpha2Code: 'LS',
  },
  'Bouvet Island': {
    flag: 'https://flagcdn.com/bv.svg',
    name: 'Bouvet Island',
    alpha2Code: 'BV',
  },
  Albania: {
    flag: 'https://flagcdn.com/al.svg',
    name: 'Albania',
    alpha2Code: 'AL',
  },
  Macao: {
    flag: 'https://flagcdn.com/mo.svg',
    name: 'Macao',
    alpha2Code: 'MO',
  },
  Kyrgyzstan: {
    flag: 'https://flagcdn.com/kg.svg',
    name: 'Kyrgyzstan',
    alpha2Code: 'KG',
  },
  Liberia: {
    flag: 'https://flagcdn.com/lr.svg',
    name: 'Liberia',
    alpha2Code: 'LR',
  },
  Bermuda: {
    flag: 'https://flagcdn.com/bm.svg',
    name: 'Bermuda',
    alpha2Code: 'BM',
  },
  Ecuador: {
    flag: 'https://flagcdn.com/ec.svg',
    name: 'Ecuador',
    alpha2Code: 'EC',
  },
  Guadeloupe: {
    flag: 'https://flagcdn.com/gp.svg',
    name: 'Guadeloupe',
    alpha2Code: 'GP',
  },
  Namibia: {
    flag: 'https://flagcdn.com/na.svg',
    name: 'Namibia',
    alpha2Code: 'NA',
  },
  Argentina: {
    flag: 'https://flagcdn.com/ar.svg',
    name: 'Argentina',
    alpha2Code: 'AR',
  },
  Liechtenstein: {
    flag: 'https://flagcdn.com/li.svg',
    name: 'Liechtenstein',
    alpha2Code: 'LI',
  },
  'Saint Martin': {
    flag: 'https://flagcdn.com/mf.svg',
    name: 'Saint Martin',
    alpha2Code: 'MF',
  },
  Dominica: {
    flag: 'https://flagcdn.com/dm.svg',
    name: 'Dominica',
    alpha2Code: 'DM',
  },
  Botswana: {
    flag: 'https://flagcdn.com/bw.svg',
    name: 'Botswana',
    alpha2Code: 'BW',
  },
  'São Tomé and Príncipe': {
    flag: 'https://flagcdn.com/st.svg',
    name: 'São Tomé and Príncipe',
    alpha2Code: 'ST',
  },
  'Burkina Faso': {
    flag: 'https://flagcdn.com/bf.svg',
    name: 'Burkina Faso',
    alpha2Code: 'BF',
  },
  Iceland: {
    flag: 'https://flagcdn.com/is.svg',
    name: 'Iceland',
    alpha2Code: 'IS',
  },
  'Sint Maarten': {
    flag: 'https://flagcdn.com/sx.svg',
    name: 'Sint Maarten',
    alpha2Code: 'SX',
  },
  'Solomon Islands': {
    flag: 'https://flagcdn.com/sb.svg',
    name: 'Solomon Islands',
    alpha2Code: 'SB',
  },
  Laos: {
    flag: 'https://flagcdn.com/la.svg',
    name: 'Laos',
    alpha2Code: 'LA',
  },
  Grenada: {
    flag: 'https://flagcdn.com/gd.svg',
    name: 'Grenada',
    alpha2Code: 'GD',
  },
  Uzbekistan: {
    flag: 'https://flagcdn.com/uz.svg',
    name: 'Uzbekistan',
    alpha2Code: 'UZ',
  },
  Morocco: {
    flag: 'https://flagcdn.com/ma.svg',
    name: 'Morocco',
    alpha2Code: 'MA',
  },
  Nauru: {
    flag: 'https://flagcdn.com/nr.svg',
    name: 'Nauru',
    alpha2Code: 'NR',
  },
  'French Polynesia': {
    flag: 'https://flagcdn.com/pf.svg',
    name: 'French Polynesia',
    alpha2Code: 'PF',
  },
  Anguilla: {
    flag: 'https://flagcdn.com/ai.svg',
    name: 'Anguilla',
    alpha2Code: 'AI',
  },
  Iraq: {
    flag: 'https://flagcdn.com/iq.svg',
    name: 'Iraq',
    alpha2Code: 'IQ',
  },
  Ghana: {
    flag: 'https://flagcdn.com/gh.svg',
    name: 'Ghana',
    alpha2Code: 'GH',
  },
  Honduras: {
    flag: 'https://flagcdn.com/hn.svg',
    name: 'Honduras',
    alpha2Code: 'HN',
  },
  Lithuania: {
    flag: 'https://flagcdn.com/lt.svg',
    name: 'Lithuania',
    alpha2Code: 'LT',
  },
  Norway: {
    flag: 'https://flagcdn.com/no.svg',
    name: 'Norway',
    alpha2Code: 'NO',
  },
  Indonesia: {
    flag: 'https://flagcdn.com/id.svg',
    name: 'Indonesia',
    alpha2Code: 'ID',
  },
  Barbados: {
    flag: 'https://flagcdn.com/bb.svg',
    name: 'Barbados',
    alpha2Code: 'BB',
  },
  'British Indian Ocean Territory': {
    flag: 'https://flagcdn.com/io.svg',
    name: 'British Indian Ocean Territory',
    alpha2Code: 'IO',
  },
  'Cocos (Keeling) Islands': {
    flag: 'https://flagcdn.com/cc.svg',
    name: 'Cocos (Keeling) Islands',
    alpha2Code: 'CC',
  },
  Nigeria: {
    flag: 'https://flagcdn.com/ng.svg',
    name: 'Nigeria',
    alpha2Code: 'NG',
  },
  Estonia: {
    flag: 'https://flagcdn.com/ee.svg',
    name: 'Estonia',
    alpha2Code: 'EE',
  },
  Israel: {
    flag: 'https://flagcdn.com/il.svg',
    name: 'Israel',
    alpha2Code: 'IL',
  },
  Brunei: {
    flag: 'https://flagcdn.com/bn.svg',
    name: 'Brunei',
    alpha2Code: 'BN',
  },
  'Sri Lanka': {
    flag: 'https://flagcdn.com/lk.svg',
    name: 'Sri Lanka',
    alpha2Code: 'LK',
  },
  Oman: {
    flag: 'https://flagcdn.com/om.svg',
    name: 'Oman',
    alpha2Code: 'OM',
  },
  'Saint Barthélemy': {
    flag: 'https://flagcdn.com/bl.svg',
    name: 'Saint Barthélemy',
    alpha2Code: 'BL',
  },
  Ireland: {
    flag: 'https://flagcdn.com/ie.svg',
    name: 'Ireland',
    alpha2Code: 'IE',
  },
  Fiji: {
    flag: 'https://flagcdn.com/fj.svg',
    name: 'Fiji',
    alpha2Code: 'FJ',
  },
  "Côte d'Ivoire": {
    flag: 'https://flagcdn.com/ci.svg',
    name: "Côte d'Ivoire",
    alpha2Code: 'CI',
  },
  Guatemala: {
    flag: 'https://flagcdn.com/gt.svg',
    name: 'Guatemala',
    alpha2Code: 'GT',
  },
  Bahamas: {
    flag: 'https://flagcdn.com/bs.svg',
    name: 'Bahamas',
    alpha2Code: 'BS',
  },
  'Saint Helena, Ascension and Tristan da Cunha': {
    flag: 'https://flagcdn.com/sh.svg',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha2Code: 'SH',
  },
  Montserrat: {
    flag: 'https://flagcdn.com/ms.svg',
    name: 'Montserrat',
    alpha2Code: 'MS',
  },
  Pakistan: {
    flag: 'https://flagcdn.com/pk.svg',
    name: 'Pakistan',
    alpha2Code: 'PK',
  },
  Chile: {
    flag: 'https://flagcdn.com/cl.svg',
    name: 'Chile',
    alpha2Code: 'CL',
  },
  Jamaica: {
    flag: 'https://flagcdn.com/jm.svg',
    name: 'Jamaica',
    alpha2Code: 'JM',
  },
  'Virgin Islands (U.S.)': {
    flag: 'https://flagcdn.com/vi.svg',
    name: 'Virgin Islands (U.S.)',
    alpha2Code: 'VI',
  },
  'Republic of the Congo': {
    flag: 'https://flagcdn.com/cg.svg',
    name: 'Republic of the Congo',
    alpha2Code: 'CG',
  },
  Yemen: {
    flag: 'https://flagcdn.com/ye.svg',
    name: 'Yemen',
    alpha2Code: 'YE',
  },
  Slovakia: {
    flag: 'https://flagcdn.com/sk.svg',
    name: 'Slovakia',
    alpha2Code: 'SK',
  },
};

export const COUNTRY_ISO_TO_NAME = {
  AF: 'Afghanistan',
  AX: 'Åland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BQ: 'Caribbean Netherlands',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  UM: 'United States Minor Outlying Islands',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  BN: 'Brunei',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cabo Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Republic of the Congo',
  CD: 'DR Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Vatican City',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  CI: "Côte d'Ivoire",
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'North Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  KP: 'North Korea',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn Islands',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  XK: 'Republic of Kosovo',
  RE: 'Réunion',
  RO: 'Romania',
  RU: 'Russia',
  RW: 'Rwanda',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'São Tomé and Príncipe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia',
  KR: 'South Korea',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'South Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SZ: 'Eswatini',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syria',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States of America',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};
